const inputAlertChange = {
  show({
    actions = [],
    onDismiss = null,
    value = "",
    total = 0,
    label = "Valor",
    placeholder = "0,00",
  }, delay = 100) {
    setTimeout(() => {
      globalThis.$events.$emit("app-bottom-sheet", {
        actions,
        component: "app-input-alert-change",
        onDismiss,
        value,
        total,
        label,
        placeholder,
      });
    }, delay);
  },

  dismiss() {
    globalThis.$events.$emit("app-bottom-sheet", { dismiss: true });
  },
};

globalThis.$inputAlertChange = inputAlertChange;

export default {
  install(Vue) {
    Vue.prototype.$inputAlertChange = inputAlertChange;
  },
};
